

export enum enumBFGDesc {
  'Microlender' = 'Microlender',
  'Office Account' = 'Office Account',
  'Client' = 'Client',
  'Zz MycoCard' = 'Zz MycoCard',
  'Zz Development' = 'Zz Development',
  'Concession' = 'Concession',
  'Zz Mycomax Group' = 'Zz Mycomax Group',
  'Business Group' = 'Business Group',
  'Zz Super Terminal' = 'Zz Super Terminal',
  'Zz MSP Client' = 'Zz MSP Client',
  'Zz KGS Group' = 'Zz KGS Group',
  'Zz KGS Pocket' = 'Zz KGS Pocket',
  'Zz Software Only' = 'Zz Software Only',
  'Zz LSP' = 'Zz LSP',
  'Concession Volume' = 'Concession Volume',
  'Business Silver' = 'Business Silver',
  'Concession Max' = 'Concession Max',
  'Microlender Max' = 'Microlender Max',
  'EPA Group' = 'EPA Group',
  'Zz Development M' = 'Zz Development M',
  'Zz CellPhone' = 'Zz CellPhone',
  'Classic' = 'Classic',
  'Classic Lite' = 'Classic Lite',
  'Wealth & Rewards' = 'Wealth & Rewards',
  'Zz PDA WR' = 'Zz PDA WR',
  'StatusMoney' = 'StatusMoney',
  'Cash Access' = 'Cash Access',
  'Business Platinum' = 'Business Platinum',
  'ZZ Professional' = 'ZZ Professional',
  'Wizzit' = 'Wizzit',
  'Wizzit Business' = 'Wizzit Business',
  'Zz WizzKids' = 'Zz WizzKids',
  'SS Terminal Supervisor Card' = 'SS Terminal Supervisor Card',
  'SS Terminal Admin Card' = 'SS Terminal Admin Card',
  'Consumer Fair' = 'Consumer Fair',
  'ePocket' = 'ePocket',
  'SureE' = 'SureE',
  'XTRA-MOVA' = 'XTRA-MOVA',
  'PayM8 Agents' = 'PayM8 Agents',
  'PayM8 Staff' = 'PayM8 Staff',
  'Percent_Zero' = 'Percent_Zero',
  'mB Insurance' = 'mB Insurance',
  'Percent_Two' = 'Percent_Two',
  'Percent_TwoFive' = 'Percent_TwoFive',
  'mB StandAlone' = 'mB StandAlone',
  'Percent_One' = 'Percent_One',
  'Universal Business' = 'Universal Business',
  'mB Full Spectrum Merchant' = 'mB Full Spectrum Merchant',
  'mB Processing' = 'mB Processing',
  'SS-SASSA' = 'SS-SASSA',
  'Flexifusion' = 'Flexifusion',
  'mB Fixed Network' = 'mB Fixed Network',
  'mB Network Wallet' = 'mB Network Wallet',
  'VPS Business' = 'VPS Business',
  'mB SME Merchant' = 'mB SME Merchant',
  'Allocated Merchant' = 'Allocated Merchant',
  'Intecon Merchant' = 'Intecon Merchant',
  'mB UGAP' = 'mB UGAP',
  'Amber Personnel' = 'Amber Personnel',
  'Business Gold' = 'Business Gold',
  'Smart D CA' = 'Smart D CA',
  'mB SME Wallet' = 'mB SME Wallet',
  'Classic X' = 'Classic X',
  'Smart CL' = 'Smart CL',
  'Paysoft' = 'Paysoft',
  'Premium' = 'Premium',
  'Premium Lite' = 'Premium Lite',
  'mB UHAP' = 'mB UHAP',
  'ZZ DO NOT USE' = 'ZZ DO NOT USE',
  'Classic Min' = 'Classic Min',
  'mB Staff Savings' = 'mB Staff Savings',
  'mB Staff GAP' = 'mB Staff GAP',
  'mB ZOOPP Savings' = 'mB ZOOPP Savings',
  'mB ZOOPP GAP' = 'mB ZOOPP GAP',
  'SureCard Savvy 5 000' = 'SureCard Savvy 5 000',
  'SureCard Smart 10 000' = 'SureCard Smart 10 000',
  'mB ZOOPP Group' = 'mB ZOOPP Group',
  'Reseller Gold' = 'Reseller Gold',
  'Reseller Platinum' = 'Reseller Platinum',
  'My Smart Cash' = 'My Smart Cash',
  'Mafori' = 'Mafori',
  'mB WSU Savings' = 'mB WSU Savings',
  'Amber Rewards' = 'Amber Rewards',
  'Smart D Cash Access' = 'Smart D Cash Access',
  'mB Eduvos' = 'mB Eduvos',
  '\u0000' = '\u0000' 
}

export namespace enumBFGDesc {
  export function values() {
    return Object.keys(enumBFGDesc).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
